import React from 'react';
import { ListItem } from '@rneui/base';
import { useUserQuery } from '@annunciate/query';
import { FAIcon } from '../../components';
import { useTheme } from '../../hooks';
export const AdminBanner = () => {
    const { user } = useUserQuery();
    const theme = useTheme();
    if (!user?.isAdmin) {
        return null;
    }
    return (React.createElement(ListItem, { containerStyle: { backgroundColor: theme?.colors.warning } },
        React.createElement(FAIcon, { name: "info", size: 16 }),
        React.createElement(ListItem.Content, null,
            React.createElement(ListItem.Title, null, "You are currently viewing this page in admin preview mode."))));
};
//# sourceMappingURL=AdminBanner.js.map